import { render, staticRenderFns } from "./templateManage.vue?vue&type=template&id=697062da&scoped=true&"
import script from "./templateManage.vue?vue&type=script&lang=js&"
export * from "./templateManage.vue?vue&type=script&lang=js&"
import style0 from "./templateManage.vue?vue&type=style&index=0&id=697062da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697062da",
  null
  
)

export default component.exports